import React, { InputHTMLAttributes, ReactNode, useEffect, useState, } from 'react';
import { Table, Button, Tooltip } from "flowbite-react";
import ApiService from '../../services/ApiServiceClass';
import { GrDocumentPdf } from "react-icons/gr";
import { useGetItemsByRequestID } from '../../hooks/RequestItems/useGetItemsByRequestID';

import { IoMdCloudDownload } from "react-icons/io";
import { IoMdLink } from "react-icons/io";
import { useUtils } from '../../hooks/useUtils';

import CustomThemeTable from '../CustomThemes/CustomThemeTable';
import { IRequestItemType } from '../../types/IRequestItemType';

interface ViewMembersFieldProps extends InputHTMLAttributes<HTMLInputElement> {
    itemNumber?: number;
    labelName?: ReactNode;    
    requestItem: IRequestItemType[];
}

const ViewItemField: React.FC<ViewMembersFieldProps> = ({ itemNumber, labelName, requestItem }) => {
    const helperUtils = useUtils();
    const [totalCost, setTotalCost] = useState(0);
    
    const handleDownload = async (id: number, fileName: string) => {
        try {
            const response = await ApiService.downloadFile(id);

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName); // or extract the file name from response headers
            document.body.appendChild(link);
            link.click();
            link.remove();

        } catch (error) {
            console.log(error);
        }
    }

    const computeTotalCost = () => {
        const totalPriceTemp = requestItem.reduce((acc: any, currentItem: any) => {            

            const totalAmount = acc + currentItem.price_nzd;

            return totalAmount;
        }, 0);
        setTotalCost(totalPriceTemp)
    }

    const FormatURL = (urlString:string) => {
        if (urlString.trim().length > 0)  {
            return <>
                <a href={urlString} target='_blank'><IoMdLink /></a>
            </>
        }

        return <></>
    }


    useEffect(() => {
        if(requestItem) {
            computeTotalCost();
        }
    }, [requestItem]);
    return (
        <div className="mb-8">
            <div className="flex">
                <div className="flex-none w-5 text-sm">{itemNumber}.</div>
                <div className="text-sm">{labelName}</div>
            </div>
            <div className="flex">
                <div className="flex-none w-5"></div>
                <div className="grow mt-3">
                    <Table theme={CustomThemeTable}>

                        <Table.Head>
                            <Table.HeadCell>Name</Table.HeadCell>
                            <Table.HeadCell>Supplier</Table.HeadCell>
                            <Table.HeadCell>PartNo/SKU</Table.HeadCell>                            
                            <Table.HeadCell>Price</Table.HeadCell>
                            <Table.HeadCell>URL</Table.HeadCell>
                            <Table.HeadCell>Quote</Table.HeadCell>
                        </Table.Head>
                        <Table.Body className="divide-y">

                            {requestItem.map((item, index) => {

                                return (
                                    <Table.Row className="bg-white dark:border-gray-700 dark:bg-gray-800" key={index}>
                                        <Table.Cell>
                                            <div className="text-blue-600 dark:text-green-700">{item.name}</div>
                                        </Table.Cell>
                                        <Table.Cell>
                                            <div className="text-blue-600 dark:text-green-700">{item.supplier}</div>
                                        </Table.Cell>
                                        <Table.Cell>
                                            <div className="text-blue-600 dark:text-green-700">{item.supplierPartNo}</div>
                                        </Table.Cell>
                                        <Table.Cell>
                                            <div className="text-blue-600 dark:text-green-700">{helperUtils.convertToMoney(item.price_nzd)} NZD</div>                                            
                                        </Table.Cell>
                                        <Table.Cell>
                                            <div className="text-blue-600 dark:text-green-700">
                                                {FormatURL(item.url)}
                                            </div>
                                        </Table.Cell>
                                        <Table.Cell>
                                            {(item.with_quote === 1) && <div className="text-red-800 dark:text-orange-500 flex items-center justify-center">
                                                <Tooltip content="Download" style="dark">
                                                    <GrDocumentPdf className="h-5 w-5 text-sm cursor-pointer" onClick={() => handleDownload(item.quote.id, item.quote.filename)} />
                                                </Tooltip>
                                            </div>
                                            }
                                        </Table.Cell>
                                    </Table.Row>
                                )
                            })}

                        </Table.Body>

                    </Table>
                </div>
            </div>
        </div>
    )
}

export default ViewItemField;

